<script setup lang="ts">


var props = defineProps<{
    status: number
}>()


function status(statusId: number){
    switch (statusId) {
        case 0:
            return "Pendente";
        case 1:
            return "Processando";
        case 2:
            return "Concluido";
        case 3:
            return "Erro";
        default:
            return "Desconhecido";
    }
}

// Define the icone function to return an icon based on status
function icone(statusId: number) {
    switch (statusId) {
        case 0:
            return "⏳";
        case 1:
            return "🔄";
        case 2:
            return "✅";
        case 3:
            return "❌";
        default:
            return "❓";
    }
}


function classeCor(statusId: number) {
    switch (statusId) {
        case 0:
            return "bg-primary";
        case 1:
            return "bg-warning";
        case 2:
            return "bg-success";
        case 3:
            return "bg-danger";
        default:
            return "bg-dark";
    }
}

</script>

<template>
    <div class="badge " :class="classeCor(props.status)">{{ icone(props.status) }} {{ status(props.status) }}</div>
</template>

<style lang="css" scoped>
    .badge {
        font-size: 100%;
    }
</style>